import { Field as BaseField, type FieldLabelProps } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { labelStyle } from './SwitchLabel.css';

type Props = FieldLabelProps;

export const SwitchLabel = ({ ...delegated }: Props) => {
  return <BaseField.Label {...delegated} className={clsxs(labelStyle, delegated.className)} nativeLabel={false} render={<span />} />;
};
